Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="formio-wizard-builder-component-title">' +
((__t = ( ctx.t(ctx.component.title) )) == null ? '' : __t) +
'</div>\n';
return __p
}